import React, {FC} from "react";
import {Tune} from "@mui/icons-material";
import {IconButton} from "@mui/material";

interface IButtonsToggleFilters {
    onclick: () => void;
}

export const ButtonsToggleFilters: FC<IButtonsToggleFilters> = ({onclick}) => {
    return (
        <IconButton
            onClick={onclick}
            sx={{
                mb: 2,
                color: theme => theme.palette.button.primary,
                "&:hover": {
                    color: theme => theme.palette.button.hover,
                },
                padding: 0,
                margin: 0,
            }}
        >
            <Tune/>
        </IconButton>
    );
};
